import * as auth from './auth'
import * as clocklog from './clocklog'
import * as emails from './emails'
import * as slack from '../../modules/slack/store/getters'
import * as users from './users'
import * as services from './services'
import * as companies from './companies'
import * as permitTypes from './permit-types'
import * as workTypes from './work-types'
import * as contacts from './contacts'
import * as files from './files'
import * as tasks from './tasks'
import * as proposals from './proposals'
import * as changeOrders from './change-orders'
import * as projects from './projects'
import * as projectContacts from './project-contacts'
import * as followedProjects from './followed-projects'
import * as projectServices from './project-services'
import * as dictionaries from './dictionaries'
import * as timelogs from './timelogs'
import * as notes from './notes'
import * as checklists from './checklists'
import * as subscribers from './subscribers'
import * as subscribedContacts from './subscribed-contacts'
import * as historicalData from './historical-data'
import * as reminders from './reminders'
import * as references from './references'
import * as activities from './activities'
import * as filings from './filings'
import * as settings from './settings'
import * as notifications from './notifications'
import * as proposalStats from './proposal-stats'
import * as applications from './applications'
import * as tableSettings from './table-settings'
import * as menu from './menu'
import * as teams from './teams'
import * as stats from './stats'
import * as globalStates from './global-states'
import * as tableViews from './table-views'

export default {
    ...clocklog,
    ...emails,
    ...slack,
    ...stats,
    ...proposalStats,
    ...applications,

    ...dictionaries,
    ...references,

    ...auth,
    ...users,
    ...teams,
    ...permitTypes,
    ...workTypes,
    ...services,
    ...companies,
    ...contacts,
    ...files,
    ...tasks,
    ...proposals,
    ...changeOrders,
    ...projects,
    ...projectContacts,
    ...followedProjects,
    ...projectServices,
    ...timelogs,
    ...notes,
    ...checklists,
    ...subscribers,
    ...subscribedContacts,
    ...historicalData,
    ...reminders,
    ...activities,
    ...filings,
    ...settings,
    ...menu,
    ...notifications,
    ...tableSettings,

    ...globalStates,

    ...tableViews,
}
